'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:NewscheduleCtrl
 * @description
 * # NewscheduleCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('NewscheduleCtrl', function ($location, $timeout, cfpLoadingBar, scheduleService, FlashService,
  lookupService, momentService) {
    var newScheduleVm = this;

    newScheduleVm.scheduleData = {
      dateCreated: '',
      recipient: '',
      monthYearForDisplay: '',
      type: ''
    };

    newScheduleVm.scheduleTypes = [{
        name: 'Maintenance'
      },
      {
        name: 'Lawncare'
      }
    ];

    newScheduleVm.scheduleUsers = [];
    newScheduleVm.inprogress = false;
    newScheduleVm.submit = _submit;

    activate();

    function activate() {
      getScheduleUsers();
    }

    function getScheduleUsers() {
      lookupService.getScheduleUsers()
      .then(function(response) {
        newScheduleVm.scheduleUsers = response;
      })
      .catch(function(error) {
        FlashService.Error(error.message);
      });
    }

    function _submit(valid) {
      if (valid) {
        newScheduleVm.inprogress = true;
        newScheduleVm.scheduleData.monthYearFor = getMonthYearFor();
        cfpLoadingBar.start();
        scheduleService.Create(newScheduleVm.scheduleData)
          .then(function(response) {
            FlashService.Success('Schedule added');
            $location.path('/schedules');
          }, function(error) {
            FlashService.Error(error.message);
          }).
          finally(function() {
            newScheduleVm.inprogress = false;
            cfpLoadingBar.complete();
          });
      }
    }

    function getMonthYearFor() {
      return momentService
        .getMonthStart(newScheduleVm.scheduleData.monthYearForDisplay)
        .format('DD/MM/YYYY');
    }

    return newScheduleVm;
  });
